import { ArrowUpRight } from "lucide-react";
import {
  FacebookIcon,
  TikTokIcon,
  YouTubeIcon,
  SnapchatIcon,
  InstagramIcon,
} from "../components/SocialIcons";
import {
  FACEBOOK_URL,
  TIKTOK_URL,
  YOUTUBE_URL,
  SNAPCHAT_URL,
  INSTAGRAM_URL,
} from "../constants";
import { JSX } from "react";

interface Social {
  name: string;
  handle: string;
  url: string;
  color: string;
  Icon: (props: { size?: number; className?: string }) => JSX.Element;
}

const socials: Social[] = [
  { name: "TikTok", handle: "@imlutuu", url: TIKTOK_URL, color: "#000000", Icon: TikTokIcon },
  { name: "Instagram", handle: "@scurtunelutu", url: INSTAGRAM_URL, color: "#E4405F", Icon: InstagramIcon },
  { name: "YouTube", handle: "@imlutuu99", url: YOUTUBE_URL, color: "#FF0000", Icon: YouTubeIcon },
  { name: "Facebook", handle: "Lutuu", url: FACEBOOK_URL, color: "#1877F2", Icon: FacebookIcon },
  { name: "Snapchat", handle: "Lutuu", url: SNAPCHAT_URL, color: "#FFFC00", Icon: SnapchatIcon },
];

export default function Follow() {
  return (
    <section className="follow-section section-pad page-offset">
      <div className="section-heading">
        <div>
          <p className="kicker">Rămâi aproape</p>
          <h2>Urmărește-ne<br /><span>pe:</span></h2>
        </div>
        <p className="heading-copy">
          Suntem prezenți pe toate rețelele. Alege platforma ta preferată și dă click pentru a fi redirecționat direct către profilul nostru.
        </p>
      </div>

      <div className="socials-grid">
        {socials.map(({ name, handle, url, color, Icon }) => (
          <a
            key={name}
            className="social-card"
            href={url}
            target="_blank"
            rel="noreferrer"
            style={{ ["--brand" as string]: color }}
          >
            <div className="social-icon"><Icon size={30} /></div>
            <div className="social-info">
              <strong>{name}</strong>
              <span>{handle}</span>
            </div>
            <ArrowUpRight className="social-arrow" size={20} />
          </a>
        ))}
      </div>
    </section>
  );
}
